import { render } from "./OrganismsPolarChart.vue?vue&type=template&id=2308555a&ts=true"
import script from "./OrganismsPolarChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsPolarChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/organisms/OrganismsPolarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2308555a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2308555a', __exports__)) {
    api.reload('2308555a', __exports__)
  }
  
  module.hot.accept("./OrganismsPolarChart.vue?vue&type=template&id=2308555a&ts=true", () => {
    api.rerender('2308555a', render)
  })

}


export default __exports__